import React from 'react'
import PropTypes from 'prop-types'
import AdSense from 'react-adsense'
import {adSenseKey} from '../utils/config'

export const Ad = ({ slot, style }) => {
	return <AdSense.Google
		client={adSenseKey}
		slot={slot}
		style={style}
		format=''
		responsive='true'
	/>
}

Ad.propTypes = {
	slot: PropTypes.string,
	style: PropTypes.object,
}

export default Ad
